var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "task-main",
    class: _vm.isMobile && 'wap'
  }, [_c('div', {
    staticClass: "search-box btns"
  }, [_c('div', {
    staticClass: "form-item"
  }, [_vm._v(" 创建时间: "), _c('m-date-range-picker', {
    attrs: {
      "valueType": "format",
      "value": _vm.time
    },
    on: {
      "update:value": function ($event) {
        _vm.time = $event;
      },
      "inputFn": _vm.onDatePickerInput
    }
  })], 1), _c('div', {
    staticClass: "form-item"
  }, [_vm._v(" 用户ID： "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.condition.userid,
      expression: "condition.userid"
    }],
    domProps: {
      "value": _vm.condition.userid
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.condition, "userid", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "form-item"
  }, [_vm._v(" username: "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.condition.username,
      expression: "condition.username"
    }],
    domProps: {
      "value": _vm.condition.username
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.condition, "username", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "form-item"
  }, [_vm._v(" firstname: "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.condition.firstname,
      expression: "condition.firstname"
    }],
    domProps: {
      "value": _vm.condition.firstname
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.condition, "firstname", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "form-item"
  }, [_vm._v(" lastname: "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.condition.lastname,
      expression: "condition.lastname"
    }],
    domProps: {
      "value": _vm.condition.lastname
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.condition, "lastname", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "form-item"
  }, [_vm._v(" 类型： "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.condition.type,
      expression: "condition.type"
    }],
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.condition, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "-1"
    }
  }, [_vm._v(" 全部 ")]), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v(" 开卡 ")]), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v(" 邀请 ")])])]), _c('div', {
    staticClass: "form-item"
  }, [_vm._v(" 状态： "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.condition.status,
      expression: "condition.status"
    }],
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.condition, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("全部")]), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("未领取")]), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("已领取")]), _c('option', {
    attrs: {
      "value": "-1"
    }
  }, [_vm._v("冻结中")])])]), _c('div', {
    staticClass: "btn btn-create",
    on: {
      "click": _vm.onRefresh
    }
  }, [_vm.isLoading ? [_vm._v("查询中...")] : [_vm._v("查询")]], 2)]), _c('div', {
    staticClass: "task-list"
  }, [_vm._m(0), _vm._l(_vm.list, function (item, index) {
    return _c('div', {
      staticClass: "task-list-item"
    }, [_c('div', {
      staticClass: "s label"
    }, [_vm._v(" " + _vm._s(_vm.cutStr(item.created_at)) + " ")]), _c('div', {
      staticClass: "s"
    }, [_vm._v(" " + _vm._s(item.user_id) + " ")]), _c('div', {
      staticClass: "s label"
    }, [_vm._v(" " + _vm._s(item.username) + " ")]), _c('div', {
      staticClass: "s label"
    }, [_vm._v(" " + _vm._s(item.firstname) + " ")]), _c('div', {
      staticClass: "s label"
    }, [_vm._v(" " + _vm._s(item.lastname) + " ")]), _c('div', {
      staticClass: "s label"
    }, [_vm._v(" " + _vm._s(_vm.cutStr(item.receive_time)) + " ")]), _c('div', {
      staticClass: "s label"
    }, [item.type == 0 ? [_vm._v(" 开卡 ")] : _vm._e(), item.type == 1 ? [_vm._v(" 邀请 ")] : _vm._e()], 2), _c('div', {
      staticClass: "s url"
    }, [_vm._l(item.reward, function (it) {
      return [_vm._v(" " + _vm._s(it.symbol) + "：" + _vm._s(it.value) + "   ")];
    })], 2), _c('div', {
      staticClass: "s label"
    }, [item.status == 0 ? [_vm._v(" 待领取 ")] : _vm._e(), item.status == 1 ? [_vm._v(" 已领取 ")] : _vm._e(), item.status == -1 ? [_vm._v(" 冻结中 ")] : _vm._e()], 2)]);
  })], 2), _c('div', {
    staticClass: "data-bd"
  }, [_c('my-pagination', {
    staticClass: "pagination",
    attrs: {
      "total": _vm.total,
      "page-size": _vm.condition.limit,
      "page": _vm.condition.page,
      "on-page-change": _vm.onPageChange,
      "on-page-size-change": _vm.onPageSizeChange
    }
  })], 1)]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "task-list-item"
  }, [_c('div', {
    staticClass: "s label"
  }, [_vm._v(" 创建时间 ")]), _c('div', {
    staticClass: "s"
  }, [_vm._v(" 用户ID ")]), _c('div', {
    staticClass: "s label"
  }, [_vm._v(" username ")]), _c('div', {
    staticClass: "s label"
  }, [_vm._v(" firstname ")]), _c('div', {
    staticClass: "s label"
  }, [_vm._v(" lastname ")]), _c('div', {
    staticClass: "s label"
  }, [_vm._v(" 领取时间 ")]), _c('div', {
    staticClass: "s label"
  }, [_vm._v(" 类型 ")]), _c('div', {
    staticClass: "s url"
  }, [_vm._v(" 奖励 ")]), _c('div', {
    staticClass: "s icon"
  }, [_vm._v(" 状态 ")])]);
}];
export { render, staticRenderFns };